// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"df80654e","455":"c82e3140","977":"ca632616"}[chunkId] + ".chunk.js";
};